import {
    apiConstants,
    config,
    downloadBlob,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest
} from "../../../Utilities/Api";
import {userData} from "../userMockData";

//************************************************** STANDARD API SERVER CALLS ****************************************


class ServeUserApprovalApi {

    static getUsers(userSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(userSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `patrons?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static approveUsers(users: Record<string, unknown>[]) {
        return sendRequest(
            requestOptions(config.URL + `patrons`,
                requestTypes.PUT,
                JSON.stringify(users),
            ),
        );
    }

    static exportUsersReport(userSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(userSearchCriteria as Record<string, string>).toString();

        return downloadBlob(
            requestOptions(`${config.URL}reports/patrons/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED));
    }

    static updateUserNotes(userId: string, notes: string) {
        return sendRequest(
            requestOptions(config.URL + `patrons/${userId}/notes`,
                requestTypes.PUT,
                JSON.stringify({ notes }),
            ),
        );
    }
}


//************************************************** MOCK API SERVER CALLS ****************************************

class MockUserApprovalApi {
    static getUsers() {
        return mockResolveApiCall( userData, "");
    }

    static approveUsers() {
        return mockResolveApiCall("", apiConstants.successMessage.approval.APPROVAL_UPDATED);
    }

    static exportUsersReport() {
        return mockResolveApiCall("", "");
    }

    static updateUserNotes() {
        return mockResolveApiCall("", "");
    }
}

export const userApprovalApi = config.environment.MODE === config.modes.SERVER ? ServeUserApprovalApi : MockUserApprovalApi;
